// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE

import * as $$Array from "bs-platform/lib/es6/array.js";
import * as Complex from "bs-platform/lib/es6/complex.js";
import * as Caml_array from "bs-platform/lib/es6/caml_array.js";

var complexZero = {
  re: 0.0,
  im: 0.0
};

function to_complex(x) {
  return {
          re: x,
          im: 0.0
        };
}

function fft(vector) {
  var n = vector.length;
  var x = Caml_array.caml_make_vect(n, complexZero);
  if (n === 1) {
    return [Caml_array.caml_array_get(vector, 0)];
  }
  var x_evens = Caml_array.caml_make_vect(n / 2 | 0, complexZero);
  var x_odds = Caml_array.caml_make_vect(n / 2 | 0, complexZero);
  $$Array.iteri((function (idx, value) {
          if (idx % 2 === 0) {
            return Caml_array.caml_array_set(x_evens, idx / 2 | 0, value);
          } else {
            return Caml_array.caml_array_set(x_odds, (idx - 1 | 0) / 2 | 0, value);
          }
        }), vector);
  var x_evens_fft = fft(x_evens);
  var x_odds_fft = fft(x_odds);
  for(var k = 0 ,k_finish = n / 2 | 0; k < k_finish; ++k){
    var t = Caml_array.caml_array_get(x_evens_fft, k);
    var exponent = Complex.exp(Complex.mul({
              re: -2.0 * Math.PI * (k / n),
              im: 0.0
            }, Complex.i));
    var e = Complex.mul(exponent, Caml_array.caml_array_get(x_odds_fft, k));
    Caml_array.caml_array_set(x, k, Complex.add(t, e));
    Caml_array.caml_array_set(x, k + (n / 2 | 0) | 0, Complex.sub(t, e));
  }
  return x;
}

export {
  complexZero ,
  to_complex ,
  fft ,
  
}
/* No side effect */
